import { useState } from 'react'

/**
 * Password input with show/hide toggle
 */
const PasswordInput = ({
  label,
  value,
  onChange,
  placeholder = '',
  error = '',
  disabled = false,
  className = ''
}) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`
            w-full px-4 py-3 pr-10 rounded-lg
            border ${error ? 'border-red-500 dark:border-red-600' : 'border-gray-300 dark:border-gray-600'}
            bg-white dark:bg-gray-800
            text-gray-900 dark:text-gray-100
            placeholder-gray-500 dark:placeholder-gray-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-600
            disabled:bg-gray-100 dark:disabled:bg-gray-700 disabled:cursor-not-allowed
            ${className}
          `}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <span className="material-icons text-sm">
            {showPassword ? 'visibility' : 'visibility_off'}
          </span>
        </button>
      </div>
      {error && <p className="text-red-500 dark:text-red-400 text-sm mt-2">{error}</p>}
    </div>
  )
}

export default PasswordInput
